export function formatDate(date, localeOptions, hideTime = false) {
  var options = localeOptions || (hideTime ? {} : { hour: 'numeric', minute: 'numeric' })
  if (!hideTime && (Date.now() - date) < 86400000) {
    // do nothing
  } else if ((Date.now() - date) < 31536000000) {
    options = Object.assign(options, { month: 'short', day: 'numeric' })
  } else {
    options = Object.assign(options, { year: 'numeric', month: 'short', day: 'numeric' })
  }
  return date.toLocaleString('en-US', options)
}
